import { render, staticRenderFns } from "./ConfirmClearAll.vue?vue&type=template&id=10dbb12c&scoped=true"
import script from "./ConfirmClearAll.vue?vue&type=script&lang=ts"
export * from "./ConfirmClearAll.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dbb12c",
  null
  
)

export default component.exports